interface ComputerWithPoliceSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithPoliceSVG = ({
  color,
  style,
}: ComputerWithPoliceSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="50"
    viewBox="0 0 35 50"
    fill="none"
  >
    <g clipPath="url(#clip0_535_19113)">
      <path
        d="M25.5806 11.6068H31.2752C32.6263 11.6068 33.7235 12.704 33.7235 14.0551V33.5328C33.7235 34.8839 32.6263 35.9811 31.2752 35.9811H3.34626C1.99516 35.9811 0.897949 34.8839 0.897949 33.5328V14.0551C0.897949 12.704 1.99516 11.6068 3.34626 11.6068H8.96832"
        stroke={color}
        strokeWidth="1.0156"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9415 35.9812L7.44531 39.7534H17.3111H27.1769L25.6807 35.9812"
        stroke={color}
        strokeWidth="1.0156"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1122 42.6097L33.9686 47.7603C34.3948 48.531 33.8417 49.4832 32.953 49.4832H1.669C0.780356 49.4832 0.227218 48.531 0.653406 47.7603L3.50977 42.6097H31.1122Z"
        stroke={color}
        strokeWidth="1.0156"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5259 20.8108L19.7501 28.6091L17.3108 31.7829L14.8716 28.6091L16.0957 20.8108"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3105 5.24125V2.92896"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1499 4.08972H18.4713"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.048 7.24521V2.7385C24.048 1.50527 23.0506 0.507812 21.8173 0.507812H12.8039C11.5707 0.507812 10.5732 1.50527 10.5732 2.7385V7.24521L10.8453 7.30868C15.1888 8.36055 19.7227 8.34242 24.0571 7.24521H24.048Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4922 9.36719C10.601 10.945 11.2176 13.4296 11.7345 14.7172C12.6866 17.093 14.7541 18.6617 17.3112 18.6617C19.8774 18.6617 21.9449 17.102 22.8879 14.7172C23.3866 13.4568 23.9942 11.0357 24.1211 9.45787"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7358 16.6215C21.7358 16.6215 26.6143 19.2693 28.4188 20.7201C28.9176 21.1191 29.3256 21.6269 29.643 22.1891C30.0964 22.9961 30.2959 23.9211 30.314 24.855L30.3956 29.0262H21.7358"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8859 16.6215C12.8859 16.6215 8.00736 19.2693 6.20286 20.7201C5.70413 21.1191 5.29608 21.6269 4.9787 22.1891C4.52531 22.9961 4.32582 23.9211 4.30768 24.855L4.22607 29.0262H12.8859"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_535_19113">
        <rect width="34.621" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithPoliceSVG;
